import { eventTracker } from '@hakimo-ui/hakimo/util';
import { Button } from '@hakimo-ui/shared/ui-base';
import { BugAntIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import { isFeedbackEnabled } from './util';

const LABEL = 'Report a bug or send feedback';

export function FeedbackButton() {
  const [open, setOpen] = useState(false);

  // Renders only where a Slack webhook is configured (UAT), so this is inert
  // everywhere else -- set HAKIMO_FEEDBACK_SLACK_WEBHOOK on the deploy.
  if (!isFeedbackEnabled()) {
    return null;
  }

  return (
    <>
      <Button
        variant="primary"
        title={LABEL}
        dataTestid="feedback-button"
        // `!rounded-full` because Button's primary variant sets rounded-md
        className="fixed bottom-24 right-6 z-40 !rounded-full px-3 py-3 shadow-lg"
        onClick={() => setOpen(true)}
        onSideEffect={eventTracker('open_feedback_modal')}
      >
        <BugAntIcon className="h-6 w-6" />
        <span className="sr-only">{LABEL}</span>
      </Button>
      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  );
}

export default FeedbackButton;
